<template>
  <div class="">
      <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl" :showCloseButton="false">
        <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
          <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
            FANTASTIC!
          </h2>
          <p>
            {{ currentPath.confirmText }}
          </p>
        </div>
        <template v-slot:footer>
          <div class="tw-mt-4 tw-flex tw-space-x-4">
            <button @click="goBack" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
              <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
            </button>

            <button @click="next" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
              <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
            </button>
          </div>
        </template>
      </Modal>
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
export default {
    name: 'DemoWizard',
    components: {
        Modal
    },
    data() {
      return {
        customerDetails: {
          address: '',
          email: '',
          customer_id: '',
          name: '',
          phone: '',
          postcode: '',
          state_id: '',
          suburb: '',
          user_id: '',
          is_guest: 0,
          order_id: localStorage.getItem('order_id') || '',
        },
        reference: null
      }
    },
    computed: {
      currentPath() {
        return this.$store.state['demoWizard'].currentPath
      }
    },
    methods: {
      goBack() {
          const paths = this.$store.state['demoWizard'].paths
          const completed = paths.filter(x => x.complete).length
          if(completed) {
            this.$store.commit('demoWizard/goToStep', 6)
          }else {
            this.$store.commit('demoWizard/goBack')
          }
          
      },
      selectType(type) {
        this.$store.commit('demoWizard/setType', type)
      },
      next() {
        this.$store.commit('orderPreview/clearItems')
        this.customerDetails.is_guest = 1

        const orderId = localStorage.getItem('order_id')
        if(orderId){
            this.$store.commit('demoWizard/goToStep', 5)
        }else {
            this.$store.dispatch('customerDetails/sendData', {customerDetails: this.customerDetails, reference: this.reference})
            .then(res => {
              
              this.$store.commit('demoWizard/goToStep', 5)
            })
        }
        
      }
    }
}
</script>

<style lang="scss">

</style>
